<template>
  <div v-if="account && account.bankAcctNum" style="padding-top:10px;">
    <van-field label="开户银行" :value="bankName" readonly size="large" />
    <van-field label="银行卡卡号" :value="account.bankAcctNum" readonly size="large" />
  </div>
</template>

<script>
import { getAccountView, bankList } from '@/api/capital';
export default {
  data() {
    return {
      account: {},
      bankName: '',
    };
  },
  created() {
    this.loadAccountView();
  },
  methods: {
    loadAccountView() {
      getAccountView()
        .then(res => {
          this.account = res.data;
          return bankList();
        })
        .then(res => {
          const bank = res.data.list.find(item => item.code === this.account.bankId);
          this.bankName = bank.name || '';
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-field__label {
  color: #333333;
  font-weight: 500;
}
</style>
